import { MorePagesTitleTheme } from '@/components/MorePagesTitle/theme';
import { GenericSlot } from 'base/components/GenericSlot';

export const MorePagesTitle = GenericSlot({ as: 'h3', theme: MorePagesTitleTheme });
